<template>
    <svg width="100%" height="100%" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 0.5C1.34143 0.5 0 1.752 0 3.3C0 5.4 3 8.5 3 8.5C3 8.5 6 5.4 6 3.3C6 1.752 4.65857 0.5 3 0.5ZM3 4.3C2.71584 4.3 2.44332 4.19464 2.24239 4.00711C2.04145 3.81957 1.92857 3.56522 1.92857 3.3C1.92857 3.03478 2.04145 2.78043 2.24239 2.59289C2.44332 2.40536 2.71584 2.3 3 2.3C3.28416 2.3 3.55668 2.40536 3.75761 2.59289C3.95855 2.78043 4.07143 3.03478 4.07143 3.3C4.07143 3.56522 3.95855 3.81957 3.75761 4.00711C3.55668 4.19464 3.28416 4.3 3 4.3Z" fill="currentColor"/>
    </svg>
</template>


